import { IconTypes } from "~/components/Icon/types";

// // // //

export interface GigatableRow {
    rank: number;
    name: string;
    ticker: string;
    url: string;
    icon_url: string;
    distributed: boolean;
    asset_class: {
        id: number;
        name: string;
        icon: IconTypes;
        url: string | null;
    };
    networks: Array<{
        name: string;
        url: string;
        icon_url: string;
        slug: string;
    }>;
    protocol: {
        name: string;
        url: string;
        icon_url: string;
    };
    value: number;
    apy_7d: number | null;
    pct_change_7d: number | null;
    pct_change_30d: number | null;
    created_at: number;
}

export enum GigatableColumns {
    rank = "rank",
    name = "name",
    protocol = "protocol",
    asset_class = "asset_class",
    networks = "networks",
    value = "value",
    apy_7d = "apy_7d",
    pct_change_7d = "pct_change_7d",
    pct_change_30d = "pct_change_30d",
    transferable = "transferable",
}
